//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { useNavigationHistory } from "components/common";
import { LocalizationHelperInstance } from "utils/helpers";
import useRemoveArticleDialog from "./useRemoveArticleDialog";

function useRemoveArticleAction(articleId: number, canRemove: boolean, onSubmitSuccess?: () => void) {
  const { goBack } = useNavigationHistory();
  const removeArticleDialog = useRemoveArticleDialog();

  const onUpdateArticleSubmitSuccess = (): any => {
    goBack();
  };

  const removeArticleMoreAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.RemoveArticle),
    icon: IconDefinitionConstants.WTrashAlt,
    highlightType: StyleEnums.DisplayType.Danger,
    actionDialog: removeArticleDialog(articleId, onUpdateArticleSubmitSuccess),
    hidden: !canRemove,
  };

  return { removeArticleMoreAction };
}

export default useRemoveArticleAction;
